import { createContext, useContext } from 'react';

const noop = () => {};

export const RecordFormDirtyContext = createContext({ markDirty: noop });

export function useMarkRecordFormDirty() {
  return useContext(RecordFormDirtyContext).markDirty;
}
